import MediaType from "./MediaType";

export default MediaType;
